import { render, staticRenderFns } from "./ManageCompanyRLS.vue?vue&type=template&id=486f5796&scoped=true"
import script from "./ManageCompanyRLS.vue?vue&type=script&lang=js"
export * from "./ManageCompanyRLS.vue?vue&type=script&lang=js"
import style0 from "./ManageCompanyRLS.vue?vue&type=style&index=0&id=486f5796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f5796",
  null
  
)

export default component.exports